export default "__VITE_ASSET__CaF5mjHB__"